"use client";

import { useContext, useEffect, useState } from "react";
import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { applyQRFormDefaultValues } from "@/utils/formHelper";
import { omittedValues } from "@/utils/qrEditorHelper";
import { qrUrlStaticValidation } from "@/utils/validators/qr-url-static";
import { QRUrlStaticProps } from "./types";
import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export function QRUrlStatic({ data }: QRUrlStaticProps) {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = useContext<QREditorContextProps<"url-static">>(QREditorContext);

  const [qrUrlStaticData, setQrUrlStaticData] = useState<QRProps<"url-static">>(qrData);
  const [renderForm, setRenderForm] = useState(false);

  const dataUrlStaticWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  const onUpdateState = ({ field, value }) => {
    if (field == "") return;
    setQrData({ ...qrData, data: { ...qrData.data, [field]: value } }, omittedValues(qrData.data));
  };

  useEffect(() => {
    setQrUrlStaticData(qrData);
  }, [qrData]);

  useEffect(() => {
    setQrData({ ...qrUrlStaticData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-url-static">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataUrlStaticWithDefaultValues}
        schema={qrUrlStaticValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
}
